import { render, staticRenderFns } from "./LinkBox.vue?vue&type=template&id=5024c58a&scoped=true&"
import script from "./LinkBox.vue?vue&type=script&lang=js&"
export * from "./LinkBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024c58a",
  null
  
)

export default component.exports